export default "__VITE_ASSET__1sNeASV4__"